import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'genera-SN',
    initialState: {
        sn_due_cifre: new Date().getFullYear().toString().substr(-2),
        sn_quattro_cifre: '0000',
        statusAction: 'READY',
    },
    actions: ['GEN_SN', 'HANDLE_CHANGE_FIELD'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {

            case types.GEN_SN_SUCCESS:
                return {
                    ...state,
                    sn_quattro_cifre: action.payload.sn_quattro_cifre
                };

            case types.HANDLE_CHANGE_FIELD:
                return {
                    ...state,
                    [action.payload.field]: action.payload.newValue,
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        //genSN
        genSNRequest: (anno) => ({
            type: types.GEN_SN_REQUEST,
            payload: { anno },
        }),
        genSNSuccess: ({ sn_quattro_cifre }) => ({
            type: types.GEN_SN_SUCCESS,
            payload: { sn_quattro_cifre },
        }),
        genSNFailed: error => ({ type: types.GEN_SN_FAILED, error: true, payload: { error } }),

        handleChangeField: (field, newValue) => ({
            type: types.HANDLE_CHANGE_FIELD,
            payload: { field, newValue },
        }),
    }),
});
